import { createSelector, createFeatureSelector } from '@ngrx/store';
import { IndustryState } from './state';
import {
  Industry,
} from '@hrra/common-models';
import { IndustryListItem } from 'src/app/shared/models/industry-model';
import { JobseekerStoreState } from '../state';

const industryState = createFeatureSelector<JobseekerStoreState>('jobseeker');

export const selectIndustries = createSelector(
  industryState,
  (s) => s?.industryList.industries
);

export const selectHeadIndustries = createSelector(
  selectIndustries,
  s => s.filter(c => c.parentId === null)
);

export const selectChildIndustries = createSelector(
  selectIndustries,
  s => s.filter(c => c.parentId !== null)
);